import { render, staticRenderFns } from "./NewUploader1.vue?vue&type=template&id=c2dbaa6e&"
import script from "./NewUploader1.vue?vue&type=script&lang=ts&"
export * from "./NewUploader1.vue?vue&type=script&lang=ts&"
import style0 from "./NewUploader1.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports